import { render, staticRenderFns } from "./MarqetaWidgetManagerV2.vue?vue&type=template&id=67ce0b0f&scoped=true"
import script from "./MarqetaWidgetManagerV2.vue?vue&type=script&lang=js"
export * from "./MarqetaWidgetManagerV2.vue?vue&type=script&lang=js"
import style0 from "./MarqetaWidgetManagerV2.vue?vue&type=style&index=0&id=67ce0b0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ce0b0f",
  null
  
)

export default component.exports